export default __webpack_public_path__ + "23ab3715fa7324334337f02b6db829a0.jpg";